export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SET_QUANTITY = 'CART_SET_QUANTITY';
export const CART_CLEAR = 'CART_CLEAR';
export const CART_SET_ALL = 'CART_SET_ALL';
export const CART_REMOVE_ITEMS = 'CART_REMOVE_ITEMS';
